<template>
  <label
    :class="['zg-input-label', {
      'zg-input-label--small': small,
      'zg-input-label--hidden': hidden
    }]"
    :for="name"
  >
    <slot />

    <span
      v-if="required"
      class="is-required"
    >
      *
    </span>

    <span
      v-if="valid"
      class="is-valid"
    >
      <zg-icon icon="valid" />
    </span>
  </label>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon'

  export default {
    name: 'ZgInputLabel',
    components: { ZgIcon },
    props: {
      name: {
        type: String,
        required: true
      },
      small: {
        type: Boolean,
        required: false,
        default: false
      },
      required: {
        type: Boolean,
        required: false,
        default: false
      },
      valid: {
        type: Boolean,
        required: false,
        default: false
      },
      hidden: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      isMounted: false
    }),
    mounted () {
      this.isMounted = true
    }
  }
</script>

<style lang="scss" scoped>
  .zg-input-label {
    @include type-body-m;

    position: absolute;
    top: 50%;
    left: input(padding-x);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: rem(4px);
    height: rem(10px);
    color: color(gray-500);
    padding: 0;
    margin: 0;
    transform: translateY(-50%);
    transform-origin: left;
    transition: all 0.3s ease;
    pointer-events: none;
    z-index: 2;

    .is-required {
      @include type-body-m;

      color: color(error-500);
      margin: 0;
    }

    .is-valid {
      display: inline-flex;
      align-items: center;

      ::v-deep svg {
        color: color(success-500);
        width: rem(16px);
        height: rem(16px);
      }
    }
  }

  .zg-input-label--small {
    @include type-body-xs;

    top: input(padding-y);
    transform: translateY(0);
    line-height: 0;
    margin: 0;

    .is-valid {
      ::v-deep svg {
        width: rem(12px);
        height: rem(12px);
      }
    }
  }

  .zg-input-label--hidden {
    @include visuallyhidden;
  }
</style>
